import { PropsWithChildren } from 'react';
import { DeprecatedEventQueueStateProvider } from '../../event-queues/deprecated/deprecated-event-queue-state-provider';
import { WorkspacePanel } from '../../panels/workspace-panel';
import { ScheduledEventQueueStateProvider } from '../../scheduled-event-queues/scheduled-event-queue-state-provider';
import { DeprecatedUnitQueueStateProvider } from '../../unit-queues/deprecated/deprecated-unit-queue-state-provider';
import { HospitalQueueStateProvider } from '../../hospital-queues/hospital-queue-state-provider';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { UnitQueueStateProvider } from '../../unit-queues/unit-queue-state-provider';
import { EventQueueStateProvider } from '../../event-queues/event-queue-state-provider';
import { WorkspacePanelProvider } from '../../panels/workspace-panel-provider';
import { BoloQueueStateProvider } from '../../bolos/bolo-queues/bolo-queue-state-provider';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function QueueStateProvider({
    workspacePanel,
    children,
}: PropsWithChildren<{
    workspacePanel: WorkspacePanel;
}>): React.ReactElement {
    const { queuesRearchitectureEnabled } = useEnabledFeatures();
    const { isFirstResponder } = useApplicationType();

    switch (workspacePanel.queue?.dataEntityType) {
        case 'CAD_AGENCY_EVENT':
            return queuesRearchitectureEnabled || isFirstResponder ? (
                <WorkspacePanelProvider workspacePanel={workspacePanel}>
                    <EventQueueStateProvider>{children}</EventQueueStateProvider>
                </WorkspacePanelProvider>
            ) : (
                <DeprecatedEventQueueStateProvider workspacePanel={workspacePanel}>
                    {children}
                </DeprecatedEventQueueStateProvider>
            );
        case 'UNIT':
            return queuesRearchitectureEnabled || isFirstResponder ? (
                <WorkspacePanelProvider workspacePanel={workspacePanel}>
                    <UnitQueueStateProvider>{children}</UnitQueueStateProvider>
                </WorkspacePanelProvider>
            ) : (
                <DeprecatedUnitQueueStateProvider workspacePanel={workspacePanel}>
                    {children}
                </DeprecatedUnitQueueStateProvider>
            );
        case 'SCHEDULED_AGENCY_EVENT':
            return (
                <ScheduledEventQueueStateProvider workspacePanel={workspacePanel}>
                    {children}
                </ScheduledEventQueueStateProvider>
            );
        case 'HOSPITAL':
            return (
                <HospitalQueueStateProvider workspacePanel={workspacePanel}>
                    {children}
                </HospitalQueueStateProvider>
            );
        case 'BOLO':
            return (
                <WorkspacePanelProvider workspacePanel={workspacePanel}>
                    <BoloQueueStateProvider>{children}</BoloQueueStateProvider>
                </WorkspacePanelProvider>
            );
        default:
            throw new Error(
                `unsupported queue entity type ${workspacePanel.queue?.dataEntityType}`
            );
    }
}
